import React from 'react';
import { View } from 'react-native';
import Colors from '../../../constants/Colorsv2';
import { Text } from '../../../globalComponents/NativeOverrides';
import { LeagueProps, MatchProps, TournamentProps } from "../../../store/types/sr_svc";

type MatchInfoCardProps = {
    match:MatchProps,
    tournament?:TournamentProps,
    league?:LeagueProps
}
const MatchInfoCard = ({ match, league, tournament }:MatchInfoCardProps) => {
    if(!match){ return <></> }
    return (
        <View style={{ padding:10, justifyContent:'center', alignItems:'center' }}>
            <View style={{ marginTop:12, borderRadius:2, backgroundColor:Colors.brand.cyan, padding:3, paddingRight:8, paddingLeft:8, alignSelf:'center' }}>
                <Text size={10} weight='semibold' color={Colors.shades.white} textAlign='center'>{league?.league_name??''}</Text>
            </View>
            <View style={{ marginTop:8 }}>
                {tournament ?
                <Text style={{ marginBottom:5 }} size={14} color={Colors.shades.black} weight='regular' textAlign='center'>{tournament.tournament_name}</Text>
                :<></>}
                <Text size={16} color={Colors.shades.black} weight='bold' textAlign='center'>{match.match_title}</Text>
            </View>
        </View>
    )
}

export default MatchInfoCard